/* DIVETTA Home return V3: history-entry scoped; never re-seek a BFCache page.
   Film owns its stable states/portal handoffs. This module owns return intent only. */
(() => {
  'use strict';
  window.DV2HomeReturn?.destroy?.();
  const abort = new AbortController();
  const {signal} = abort;
  const VERSION = 3, TTL = 30 * 60 * 1000;
  const FIELD = 'dv2HomeReturn', TOKEN = 'dv2HomeEntry', PREFIX = 'ld_home_return_v3:';
  const WORLDS = ['viso', 'capelli', 'corpo', 'makeup', 'epilogue'];
  const rootPath = new URL(window.Shopify?.routes?.root || '/', location.origin).pathname;
  const isHome = () => location.pathname.replace(/\/$/, '') === rootPath.replace(/\/$/, '');
  let restoring = false, attempted = false, timer = 0, frame = 0, pending = null;
  const historyObject = () => history.state && typeof history.state === 'object' && !Array.isArray(history.state) ? history.state : {};
  const valid = (record, token) => record?.version === VERSION && record.token === token &&
    record.sourcePath === rootPath && ['hero','film','page'].includes(record.mode) &&
    Number.isFinite(record.scrollY) && record.scrollY >= 0 &&
    Number.isFinite(record.timestamp) && Date.now() >= record.timestamp && Date.now() - record.timestamp <= TTL &&
    (record.mode !== 'film' || WORLDS.includes(record.worldId));

  function read() {
    const state = historyObject(), token = state[TOKEN];
    if (typeof token !== 'string' || !token || !isHome()) return null;
    if (valid(state[FIELD], token)) return state[FIELD];
    try { const record = JSON.parse(sessionStorage.getItem(PREFIX + token)); return valid(record, token) ? record : null; }
    catch (_) { return null; }
  }
  const masterReady = () => {
    const instance = window.DV2Home?.getInstance?.();
    return Boolean(instance && !instance.destroyed && instance.root?.dataset.ldHomeFilmReady === 'true' && instance.root?.dataset.ldHomeStateOwner === 'ld-home-scroll-film');
  };
  const report = (result, method, record) => document.dispatchEvent(new CustomEvent('dv2_restore_result', {
    detail: {result, method, world_id: record?.worldId || '', mode: record?.mode || ''}
  }));

  function capture(link) {
    if (!isHome() || window.Shopify?.designMode || restoring || !masterReady()) return null;
    const instance = window.DV2Home.getInstance();
    const y = Math.max(0, scrollY);
    const filmWrapper = instance.root.closest('.shopify-section') || instance.root;
    const header = document.getElementById('header-group')?.getBoundingClientRect().height || 0;
    const point = y + header + 40;
    const sections = Array.from(document.querySelectorAll('main .shopify-section[id], #footer-group'));
    const anchor = sections.find((node) => {
      const rect = node.getBoundingClientRect();
      return rect.height > 0 && rect.top + y <= point && rect.bottom + y > point;
    });
    const outside = anchor && anchor !== filmWrapper && !filmWrapper.contains(anchor);
    const nativePage = outside || (instance.journeyReleased && instance.root.getBoundingClientRect().bottom < innerHeight * .3);
    const world = WORLDS.includes(instance.activeWorld) ? instance.activeWorld : null;
    const token = historyObject()[TOKEN] || (crypto.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`);
    const record = {
      version: VERSION, token, timestamp: Date.now(), sourcePath: rootPath,
      mode: nativePage ? 'page' : world ? 'film' : 'hero', worldId: world || '', scrollY: y,
      anchorId: nativePage ? anchor?.id || '' : '',
      anchorOffset: nativePage && anchor ? -anchor.getBoundingClientRect().top : 0,
      triggerId: link?.id || ''
    };
    try { history.replaceState({...historyObject(), [TOKEN]: token, [FIELD]: record}, '', location.href); }
    catch (_) { return null; } // A different history entry must never consume this snapshot.
    try { sessionStorage.setItem(PREFIX + token, JSON.stringify(record)); } catch (_) {}
    return record;
  }
  function saveForLink(link) {
    if (!(link instanceof HTMLAnchorElement) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return null;
    try {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return null;
      if (url.pathname === location.pathname && url.search === location.search) return null;
      return capture(link);
    } catch (_) { return null; }
  }
  function cancel() {
    clearTimeout(timer); cancelAnimationFrame(frame); timer = frame = 0;
    pending = null; restoring = false;
    document.documentElement.removeAttribute('data-dv2-return-restoring');
  }
  function apply(record) {
    if (!masterReady() || !restoring) return false;
    const instance = window.DV2Home.getInstance();
    let success = true;
    if (record.mode === 'hero') success = instance.returnToIntroReadyV11?.() === true;
    else if (record.mode === 'film') success = instance.jumpToStableWorld?.(record.worldId) === true;
    else {
      // Release the film's own scroll lock before restoring App/footer native position.
      success = instance.jumpToStableWorld?.('epilogue') === true;
      if (success) instance.journeyReleased = true;
    }
    if (!success) { report('restore-failed', 'history-entry', record); cancel(); return false; }
    frame = requestAnimationFrame(() => {
      if (!restoring) return;
      if (record.mode === 'page') {
        const anchor = record.anchorId ? document.getElementById(record.anchorId) : null;
        const y = anchor && Number.isFinite(record.anchorOffset)
          ? anchor.getBoundingClientRect().top + scrollY + record.anchorOffset : record.scrollY;
        scrollTo({top: Math.max(0, y), behavior: 'instant'});
      }
      report('restored', 'history-entry', record);
      cancel();
    });
    return true;
  }
  function attempt() {
    if (attempted || !isHome() || window.Shopify?.designMode) return;
    attempted = true;
    const navigation = performance.getEntriesByType?.('navigation')?.[0]?.type;
    if (!['back_forward','reload'].includes(navigation)) return;
    const record = read();
    if (!record) return;
    restoring = true;
    document.documentElement.dataset.dv2ReturnRestoring = 'true';
    const deadline = performance.now() + 8000;
    pending = () => {
      if (!restoring) return;
      if (masterReady()) { apply(record); return; }
      if (performance.now() >= deadline) { report('master-unavailable', 'native-fallback', record); cancel(); return; }
      timer = setTimeout(pending, 100);
    };
    pending();
  }
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    saveForLink(event.target instanceof Element ? event.target.closest('a[href]') : null);
  }, {capture: true, signal});
  window.addEventListener('pagehide', () => { if (!restoring) capture(); cancel(); }, {signal});
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      cancel(); attempted = true;
      // Browser restored DOM, video state and scroll together; do not force a category.
      report('preserved', 'bfcache-native', read());
    } else attempt();
  }, {signal});
  for (const event of ['wheel','touchstart','pointerdown','keydown']) {
    window.addEventListener(event, () => { if (restoring) cancel(); }, {passive: true, signal});
  }
  document.addEventListener('dv2:home:ready', () => { if (restoring && pending) { clearTimeout(timer); pending(); } }, {signal});
  window.DV2HomeReturn = Object.freeze({
    saveForLink, read, masterReady, isRestoring: () => restoring,
    clear() {
      cancel(); const state = {...historyObject()}, token = state[TOKEN];
      delete state[FIELD]; delete state[TOKEN];
      try { history.replaceState(state, '', location.href); } catch (_) {}
      try { if (token) sessionStorage.removeItem(PREFIX + token); } catch (_) {}
    },
    destroy() { abort.abort(); cancel(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attempt, {once: true, signal});
  else attempt();
})();
